import React, { useCallback, useContext, useEffect } from "react";
import { Transition, Dialog } from "@headlessui/react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getData } from "actions";
import {
  API_URL_agent,
  API_URL_department,
  API_URL_updateBatchTicket,
} from "constants/api";
import { agentReducers } from "redux/agentSlice";
import { toast } from "react-toastify";
import axios from "axios";
import { AuthContext } from "context/AuthContext";
import { departmentReducers } from "redux/departmentSlice";

const ModalAssignBatch = ({ isOpen, onClose, item, callback }) => {
  const cancelButtonRef = React.useRef(null);
  const dispatch = useDispatch();
  const {
    datauser,
    updateCountTicket,
    setUpdateCountTicket,
    updateNotification,
    setUpdateNotification,
  } = useContext(AuthContext);

  const { getAgentResult, getDepartmentResult } = useSelector((state) => ({
    getAgentResult: state.agent.getAgentResult,
    getDepartmentResult: state.department.getDepartmentResult,
  }));

  const getAgent = useCallback(
    async (params) => {
      getData(
        API_URL_agent,
        params,
        { dispatch, redux: agentReducers },
        "GET_AGENT"
      );
    },
    [dispatch]
  );

  const getDepartment = useCallback(
    async (params) => {
      getData(
        API_URL_department,
        params,
        { dispatch, redux: departmentReducers },
        "GET_DEPARTMENT"
      );
    },
    [dispatch]
  );

  const formik = useFormik({
    initialValues: {
      assign: "",
    },
    validationSchema: Yup.object({
      assign: Yup.string().required("Assign is required"),
    }),
    onSubmit: (values) => {
      let dataUpdate = [];

      function getPrefix(inputString) {
        const prefix = inputString.split("_")[0];
        return prefix;
      }
      function getValue(inputString) {
        const value = inputString.split("_")[1];
        return value;
      }

      const departmentOrUser = getPrefix(values.assign);

      if (departmentOrUser === "department") {
        item &&
          item.map((val, index) => {
            const data = {
              id: val,
              department_manager: getValue(values.assign),
              assigned_to: null,
              by_user: datauser.id,
            };
            dataUpdate.push(data);
          });
      } else {
        item &&
          item.map((val, index) => {
            const data = {
              id: val,
              assigned_to: getValue(values.assign),
              department_manager: null,
              by_user: datauser.id,
            };
            dataUpdate.push(data);
          });
      }

      axios({
        headers: {
          Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
        },
        method: "POST",
        data: { updates: dataUpdate },
        url: API_URL_updateBatchTicket,
      })
        .then((response) => {
          setUpdateCountTicket(!updateCountTicket);
          toast.success("Ticket Assigned Successfully", {
            position: "top-center",
            autoClose: true,
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setUpdateNotification(!updateNotification);
          setTimeout(() => {
            callback();
          }, 1000);
        })
        .catch((error) => {
          console.log(error);
          callback();
        });

      // Tutup modal
      onClose();
    },
  });

  useEffect(() => {
    if (datauser !== "") {
      const permission = datauser.group_permissions;
      const can_assign_ticket_all_department = permission.includes(
        "can_assign_ticket_all_department"
      );
      if (can_assign_ticket_all_department) {
        const paramsAgent = `?limit=${9999999}&role_group=!user&is_active=1&ordering=first_name`;
        const params = `?limit=${9999999}&ordering=name`;
        getAgent(paramsAgent);
        getDepartment(params);
      } else {
        const paramsAgent = `?limit=${9999999}&role_group=!user&is_active=1&id_department=${
          datauser.primary_dpt
        }&ordering=first_name`;
        const params = `?limit=${9999999}&id=${
          datauser.primary_dpt
        }&ordering=name`;
        getAgent(paramsAgent);
        getDepartment(params);
      }
    }
  }, [isOpen]);

  return (
    <Transition.Root show={isOpen} as={React.Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        initialFocus={cancelButtonRef}
        onClose={onClose}
      >
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-start justify-center p-4">
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-al w-full lg:w-1/2">
                <form onSubmit={formik.handleSubmit}>
                  <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="mt-3 sm:ml-4 sm:mt-0">
                      <div className="flex justify-between">
                        <Dialog.Title
                          as="h3"
                          className="text-2xl font-semibold leading-6 text-gray-900"
                        >
                          Assign
                        </Dialog.Title>
                        <button
                          type="button"
                          className=" bg-gray-300 px-3 py-2 text-sm font-semibold text-black shadow-sm hover:bg-gray-400"
                          onClick={onClose}
                        >
                          X
                        </button>
                      </div>

                      <hr className="my-2" />
                      <div className="px-6 py-1">
                        <label htmlFor="link" className="block mb-1">
                          Choose Who to Assign
                          <span className="text-red-500">*</span>
                        </label>
                        <select
                          id="assign"
                          name="assign"
                          value={formik.values.assign}
                          onChange={formik.handleChange}
                          className="block w-full rounded-md border border-gray-500 bg-white py-2 px-2 text-gray-900 shadow-sm focus:ring-1 focus:ring-inset focus:ring-blue-400 sm:text-sm sm:leading-6"
                        >
                          <option value="">Select</option>

                          <optgroup
                            label={`Department Manager (${
                              getDepartmentResult.results &&
                              getDepartmentResult.results.length
                            })`}
                          >
                            {getDepartmentResult.results &&
                              getDepartmentResult.results.map((item, index) => (
                                <option
                                  key={index}
                                  value={`department_${item.manager}`}
                                >
                                  {item.name} ({item.manager_name})
                                </option>
                              ))}
                          </optgroup>

                          <optgroup
                            label={`Agent (${
                              getAgentResult.results &&
                              getAgentResult.results.length
                            })`}
                          >
                            {getAgentResult.results &&
                              getAgentResult.results.map((item, index) => (
                                <option key={index} value={`user_${item.id}`}>
                                  {item.full_name}
                                </option>
                              ))}
                          </optgroup>
                        </select>
                        {formik.touched.assign && formik.errors.assign && (
                          <div className="text-red-500 dark:text-red-300 text-xs">
                            {formik.errors.assign}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 flex justify-between px-4 py-3 sm:px-6">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md bg-gray-300 px-3 py-2 text-sm font-semibold text-black shadow-sm hover:bg-gray-400"
                      onClick={onClose}
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      className="inline-flex justify-center rounded-md bg-sky-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sky-600"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default ModalAssignBatch;
